import React from 'react';
import PropTypes from 'prop-types';

import { Location } from 'models/locations';
import Booking from 'models/booking';

import LocationImage from 'components/location/image';
import LocationImageHeader from 'components/location/image/header';

const propTypes = {
  booking: PropTypes.instanceOf(Booking).isRequired,
  location: PropTypes.instanceOf(Location).isRequired,
};

const PastBookingModalImage = ({ booking, location }) => {
  if (booking.onDemand) {
    return (
      <div className="padding-15 background-color-transparent-black-70 text-color-white text-weight-book margin-bottom-20">
        <LocationImageHeader location={location} />
      </div>
    );
  }

  return (
    <LocationImage location={location}>
      <LocationImageHeader location={location} />
    </LocationImage>
  );
};

PastBookingModalImage.propTypes = propTypes;
export default PastBookingModalImage;
